export default __webpack_public_path__ + "static/media/0x7ff2fc33e161e3b1c6511b934f0209d304267857.8d773dbd.svg";